
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.318000000000001 2.146l4.536 4.536a.5.5 0 01.146.353V21.5a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h10.465a.5.5 0 01.353.146zM15.586 0H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.414a1 1 0 00-.293-.707L16.293.293A1 1 0 0015.586 0z"}}),_c('path',{attrs:{"d":"M16 11H7a1 1 0 010-2h9a1 1 0 010 2zM16 15H7a1 1 0 010-2h9a1 1 0 010 2zM11.5 19H7a1 1 0 010-2h4.5a1 1 0 010 2z"}})])
          )
        }
      }
    